import React from "react";
import { useParams } from "react-router-dom";

export default function FloatingSave({ onSave }) {
  const { submissionid } = useParams();

  return (
    <div className="text-center" onClick={onSave}>
      <i
        className="far fa-save fa-2x floating-button floating-save rounded-circle pt-2 text-white"
        style={{ backgroundColor: !submissionid ? "#ff0000" : "#28a745" }}
      />
    </div>
  );
}
